import { useScrollReveal } from '../../../hooks/useScrollReveal';

interface FinalCTAProps {
  onOpenContact: () => void;
}

export default function FinalCTA({ onOpenContact }: FinalCTAProps) {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-purple-800 to-gray-900">
        <img
          src="https://public.readdy.ai/ai/img_res/44f83acbdae88ac1d60e970662815c39.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div
          ref={ref}
          className={`transition-all ease-out ${
            isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-12 scale-95'
          }`}
          style={{ transitionDuration: '900ms', transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }}
        >
          <h2 className="text-4xl md:text-6xl font-extralight text-white mb-6 leading-tight">
            Pronto para dar voz à<br />
            <span className="font-light text-purple-300">alma do seu negócio?</span>
          </h2>

          <p
            className={`text-lg md:text-xl text-gray-300 font-light mb-12 max-w-3xl mx-auto leading-relaxed transition-all ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDuration: '800ms', transitionDelay: '200ms' }}
          >
            Deixe a complexidade do digital conosco. Vamos arquitetar juntos o futuro da sua marca.
          </p>

          <div
            className={`transition-all ease-out ${
              isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-95'
            }`}
            style={{ transitionDuration: '700ms', transitionDelay: '400ms', transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }}
          >
            <button
              onClick={onOpenContact}
              className="inline-block px-10 py-4 bg-white text-purple-900 text-base font-light tracking-wide rounded-full hover:bg-gray-100 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-2xl"
            >
              Falar com um Especialista agora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
